;(function () {
  'use strict'

  angular.module('deskfy.arts').controller('QrcodeController', QrcodeController)

  /* @ngInject */
  function QrcodeController ($scope) {
    function getUrlQrcode (location) {
      const urlQrcode = {
        workflow: `deskfy-app://AllAttachsPreview/${$scope.$root.oUser.customerCompanyId}/${
          $scope.art.assetId
        }/qrcode/task/${$scope.art.contextData?.task?.id}`,
        posts: `deskfy-app://AllAttachsPreview/${$scope.$root.oUser.customerCompanyId}/${
          $scope.art.post_has_asset?.assetId
        }/qrcode/announcements/${$scope.art.post_has_asset?.postId}`
      }
      return (
        urlQrcode[location] ||
        `deskfy-app://MaterialPreview/${$scope.$root.oUser.customerCompanyId}/${$scope.art.id}/qrcode/isArt`
      )
    }

    $scope.url = getUrlQrcode($scope.art.location)

    activate()

    function activate () {}
  }
})()
